// Static content for the activate-partner flow.
// Everything the flow renders lives here so it can be swapped for API data later.

export const PARTNER_STEPS = [
  "Partner identity",
  "Who you refer",
  "Review and activate",
];

export const PARTNER_STEP_INTRO = {
  1: {
    title: "Your partner profile",
    subtitle: "This is what kimbocorp clients see when we introduce you. Keep it short and specific.",
  },
  2: {
    title: "Your goal",
    subtitle: "Tell us what you want from the partnership. We use it to match you with the right clients.",
  },
  3: {
    title: "Review and activate",
    subtitle: "This is how kimbocorp clients will see you. Check it, then activate.",
  },
};

export const PARTNER_SKILL_OPTIONS = [
  "Digital marketing",
  "Content marketing",
  "Social media marketing",
  "Email marketing",
  "Partnership development",
  "Business development",
  "Corporate advisory",
  "Tax advisory",
  "Accounting",
  "Legal services",
  "Wealth management",
  "Compliance & risk",
];

export const PARTNER_GOALS = [
  {
    key: "start_advisory_practice",
    name: "I want to start my advisory practice",
    description: "Set up your advisory practice on kimbocorp and start working with clients.",
  },
];

export const PARTNER_GOAL_INFO =
  "Pick one.";

export const PARTNER_OBJECTIVES = [
  "Service Offer Design",
  "Target Market Research",
  "Client Acquisition Systems",
  "Professional Brand Positioning",
  "Partnership Development",
  "Network Building Strategy",
  "Service Pricing Structure",
  "Client Relationship Management",
];

// The first N objectives are pre-selected, as in the app.
export const PARTNER_DEFAULT_OBJECTIVE_COUNT = 5;

export const PARTNER_OBJECTIVE_INFO =
  "Your objectives are the focus areas you want to advise on. We use them to generate your objective statement and match you with the right clients.";

export const PARTNER_GOAL_QUESTION = "What do you want from kimbocorp?";

// Static objective statement shown in step 2.3 (will be AI generated later).
export const PARTNER_DEFAULT_STATEMENT = {
  title: "Design Services Select Markets Build Client Networks",
  body: "I am keen to design a clear advisory service offer, select the right target market, and create a practical client acquisition plan while developing referral networks and building partnership pipelines that generate qualified opportunities and establish my independent practice.",
};

export const PARTNER_STATEMENT_INFO =
  "Your objective statement is generated from your goal and objectives. It guides your campaign and you can edit it at any time.";

// Step 2.4 audience groups. Option values are loaded dynamically.
export const PARTNER_AUDIENCE_GROUPS = [
  { key: "role", title: "Their role" },
  { key: "location", title: "Where they are" },
  { key: "industry", title: "Their industry" },
];

export const PARTNER_AUDIENCE_OPTIONS = {
  role: ["Manager", "Director", "CEO", "Founder"],
  location: ["Singapore", "India", "Malaysia", "Indonesia"],
  industry: ["Management Consulting"],
};

export const PARTNER_AUDIENCE_INFO =
  "Choose the people you want to work with. A focused audience helps us match you with the right clients.";

export const PARTNER_RECOMMENDED_PLAN = {
  planName: "Partner Growth",
  whoItsFor: "Advisory firms that want a steady flow of matched clients and referral opportunities.",
  whatsIncluded: "Partner profile listing, client matching, up to 5 team seats and a dedicated partner manager.",
};

export const PARTNER_DEMO_USER = {
  first_name: "Ramneek",
  last_name: "Singh",
  email: "ramneek.singh@email.com",
};

// Shown after the partner account is activated.
export const PARTNER_SUCCESS = {
  title: "You’re a kimbocorp partner",
  message: "Your partner profile is live. Next, sign in to the app and generate your referral link. Every chat, sign-up and payment that comes through it is credited to you automatically.",
  nextSteps: [
    "Sign in to the app (your login details are in your email)",
    "Generate your referral link",
    "Join the weekly partner briefing",
  ],
  // appAction: "Open the kimbocorp app",
  briefingAction: "Join the weekly briefing",
  briefingUrl: "http://calendly.com/kimbocorp/commercial-advisors-weekly-briefing",
};
